export default {"src":"/_next/static/image/public/images/ic_radio_male.3c08224b291444670fe0c993e88040c3.svg","height":25,"width":24};